import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { lower } from 'change-case'
import { Field } from 'redux-form'
import { Card, CardContent } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { ProjectManagerContainer } from './styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'

const ProjectManager = (props) => {
  const { valueForm={}, members, memberLoading, isDisplay=false, editMode=false } = props
  
  useEffect(() => {
    if (!members.length && !memberLoading) {
      props.getAllMembers()
      // props.getHrmsMembers()
    }
  }, [])

  const memberOptions = members.filter(x => x.goaLevel > 5).map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && (valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return !isDisplay
    }
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardContent>
        <ProjectManagerContainer>
          <div className='rowFields'>
            <Field 
              name='projectManagerUser' 
              label='Project Manager/Head BU' 
              // require
              editable={editableForm() || editMode}
              ignoreClearValue={false}
              loading={memberLoading}
              options={memberOptions} 
              type={type.select}
              component={FieldInput} />
          </div>
        </ProjectManagerContainer>
      </CardContent>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formBankGuarantee')(state) || {},
    members: state.member.members,
    memberLoading: state.member.memberLoading,
  })
}
  
const mapDispatchToProps = {
  getHrmsMembers,
  getAllMembers
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManager)